"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrefetchProvider = exports.setPreloads = exports.PreloadContext = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

exports.PreloadContext = (0, react_1.createContext)({});
var preloads = {};
var updaters = [];

var setPreloads = function setPreloads(updater) {
  preloads = updater(preloads);
  updaters.forEach(function (u) {
    return u();
  });
};

exports.setPreloads = setPreloads;

var PrefetchProvider = function PrefetchProvider(_ref) {
  var children = _ref.children;

  var _ref2 = (0, react_1.useState)(function () {
    return preloads;
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      _preloads = _ref3[0],
      _setPreloads = _ref3[1];

  (0, react_1.useEffect)(function () {
    var updaterFunction = function updaterFunction() {
      _setPreloads(preloads);
    };

    updaters.push(updaterFunction);
    return function () {
      updaters = updaters.filter(function (u) {
        return u !== updaterFunction;
      });
    };
  }, []);
  return (0, jsx_runtime_1.jsx)(exports.PreloadContext.Provider, {
    value: _preloads,
    children: children
  });
};

exports.PrefetchProvider = PrefetchProvider;